// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"45c85f50","977":"6fea4c89"}[chunkId] + ".chunk.js";
};